import { BigNumber } from 'ethers'

import { toFloat } from '~/contracts/utils'

import { WEEKS_IN_YEAR } from './constants'
import { SIS_DECIMALS } from './SISDecimals'

export function getVESISAPR(part: BigNumber, total: BigNumber) {
	const value = toFloat(part, SIS_DECIMALS)
	const totalValue = toFloat(total, SIS_DECIMALS)

	return (100 * (value * WEEKS_IN_YEAR)) / totalValue
}
